export default "__VITE_ASSET__7f390315__"